module.exports = __webpack_public_path__ + "static/media/Back_4.9d8ba801.jpg";